import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { MBWStageDownload, StageComponentInterface } from '../../../../../interfaces/pagebuilder';
import { createDisplayLink } from '../../../../../services/helper';
import { VyImage } from '../../../../common/VyImage';

interface MbwDownloadItemProps {
  download: MBWStageDownload;
  iconColor?: string;
}
const MbwDownloadItem = ({ download, iconColor }: MbwDownloadItemProps) => {
  function handleDownload() {
    const url = createDisplayLink(download.file);
    window.open(url, '_blank');
  }

  return (
    <div className="flex w-full p-4 animation-fadeIn">
      <div className="flex items-center justify-center">
        <div onClick={handleDownload} className="cursor-pointer">
          <FontAwesomeIcon size="2x" icon={faDownload} color={iconColor ?? 'white'} />
        </div>
      </div>
      <div className="flex flex-col justify-center flex-1 pl-8 pr-8 font-bold cursor-pointer" onClick={handleDownload}>
        <span>{download.title}</span>
        <span className="text-md md:text-lg">{download.description}</span>
      </div>
      {download.thumbnail && (
        <div className="flex items-center justify-center w-16 h-auto overflow-hidden cursor-pointer md:w-24" onClick={handleDownload}>
          <VyImage id={download.thumbnail} returnPlaceholder={true} />
        </div>
      )}
    </div>
  );
};

export default MbwDownloadItem;
